import * as Yup from "yup";
import { registrationDobSchema } from "../../../Register/Register.validator";

const namePattern = /^[A-Za-z0-9 ]+$/;

const buildInsuranceInformationSchema = (requireHolderFields) =>
  Yup.object().shape({
    provider: Yup.string()
      .trim()
      .required("NUTRITION_INSMANUAL_VAL_SELECT_PROVIDER"),
    firstName: Yup.string()
      .trim("SPACE_VALIDATION")
      .strict(true)
      .matches(namePattern, "SPECIAL_CHAR_VALIDATION")
      .min(1, "FIRST_NAME_REQ_VALIDATION")
      .required("FIRST_NAME_REQ_VALIDATION"),
    lastName: Yup.string()
      .trim("SPACE_VALIDATION")
      .strict(true)
      .matches(namePattern, "SPECIAL_CHAR_VALIDATION")
      .min(1, "LAST_NAME_REQ_VALIDATION")
      .required("LAST_NAME_REQ_VALIDATION"),
    dob: registrationDobSchema("NUTRITION_INSMANUAL_VAL_HOLDER_DOB"),
    memberId: Yup.string().trim().required("NUTRITION_INSMANUAL_VAL_MEMBER_ID"),
    relationship: Yup.string()
      .trim()
      .required("NUTRITION_INSMANUAL_VAL_RELATIONSHIP"),
    groupNumber: Yup.string().trim().nullable(),
    holderFirstName: requireHolderFields
      ? Yup.string()
          .trim()
          .required("NUTRITION_INSMANUAL_VAL_HOLDER_FIRST_NAME")
      : Yup.string().trim().nullable(),
    holderLastName: requireHolderFields
      ? Yup.string()
          .trim()
          .required("NUTRITION_INSMANUAL_VAL_HOLDER_LAST_NAME")
      : Yup.string().trim().nullable(),
    holderDob: requireHolderFields
      ? registrationDobSchema("NUTRITION_INSMANUAL_VAL_HOLDER_DOB")
      : Yup.string().trim().nullable(),
  });

export const getInsuranceHolderDobValidationError = (
  holderDob,
  shouldValidate = true
) => {
  if (!shouldValidate) {
    return null;
  }
  try {
    registrationDobSchema("NUTRITION_INSMANUAL_VAL_HOLDER_DOB").validateSync(
      holderDob
    );
    return null;
  } catch (error) {
    return error?.message || null;
  }
};

export const getInsuranceMemberDobValidationError = (
  dob,
  shouldValidate = true
) => getInsuranceHolderDobValidationError(dob, shouldValidate);

export const getInsuranceInformationFieldErrors = (
  form,
  requireHolderFields = false
) => {
  try {
    buildInsuranceInformationSchema(requireHolderFields).validateSync(form, {
      abortEarly: false,
    });
    return {};
  } catch (error) {
    const fieldErrors = {};
    if (Array.isArray(error?.inner) && error.inner.length > 0) {
      error.inner.forEach((item) => {
        if (item.path && !fieldErrors[item.path]) {
          fieldErrors[item.path] = item.message;
        }
      });
      return fieldErrors;
    }
    if (error?.path) {
      fieldErrors[error.path] = error.message;
    }
    return fieldErrors;
  }
};

export const getInsuranceInformationValidationError = (
  form,
  requireHolderFields = false
) => {
  try {
    buildInsuranceInformationSchema(requireHolderFields).validateSync(form, {
      abortEarly: true,
    });
    return null;
  } catch (error) {
    return error?.message || null;
  }
};

export const isInsuranceInformationFormComplete = (
  form,
  requireHolderFields = false
) => getInsuranceInformationValidationError(form, requireHolderFields) === null;
